import React from 'react'
import v4 from 'uuid/v4'

const ListInfo = ({attrs = {}}) => {
	// Gestion des props manquantes avec valeurs par défaut
	const safeAttrs = {
		listinfoContent: Array.isArray(attrs?.listinfoContent) ? attrs.listinfoContent : []
	}

	return (
		<div className="block-listinfo">
			{safeAttrs.listinfoContent && safeAttrs.listinfoContent.map(({title, info, description}) => {
				// Gestion des propriétés manquantes des items
				const safeTitle = title || 'Information sans titre'
				const safeInfo = info || ''
				const safeDescription = description || null
				
				return (
					<div className="element" key={v4()}>
						<p className="title">{safeTitle}</p>
						<div className="info" dangerouslySetInnerHTML={{__html: safeInfo}}/>
						{safeDescription && (
							<div className="description" dangerouslySetInnerHTML={{__html: safeDescription}}/>
						)}
					</div>
				)
			})}
		</div>
	)
}

export default ListInfo
